<!--
 * @Author: your name
 * @Date: 2021-07-05 16:42:20
 * @LastEditTime: 2025-04-21 11:09:04
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\App.vue
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import HelloWorld from '../../components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    // HelloWorld
  },
  created() {
    // this.$cookies.set("epec-gray-group", 'uat-a', null, '/', ".epec.com");
    this.$store.dispatch('getData_userInfo');
  },
  mounted() {
    const timer = setTimeout(() => {
      // 获取菜单集合
      this.$store.dispatch('get_menuList');
      clearTimeout(timer);
    }, 1000);
  },
};
</script>

<style lang="scss">
@import '../../assets/css/main.css';
@import '../../assets/css/mixin/flex.scss';
@import '../../assets/css/color-dark.css'; /*深色主题*/
@import '../../assets/css/theme.scss';
// @import '../../assets/css/element-var.scss';

#app {
  .el-input__inner {
    border-radius: 0;
    border-color: #d9d9d9;
    &::placeholder {
      color: #999999;
    }
    .el-button {
      border-radius: 0;
    }
  }
  .el-range-input {
    &::placeholder {
      color: #999999;
    }
  }
  .el-textarea__inner {
    border-radius: 0;
    border-color: #d9d9d9;
    &::placeholder {
      color: #999999;
    }
  }
  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    position: relative;
    background: rgba(244, 247, 255, 1);
    // border-top: 2px solid rgba(37, 135, 255, 1);
    &:before {
      content: '';
      width: 100%;
      height: 2px;
      background: rgba(37, 135, 255, 1);
      position: absolute;
      left: 0;
    }
  }

  .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border-radius: 0;
  }
}
div#driver-highlighted-element-stage,
div#driver-page-overlay {
  background: transparent !important;
  outline: 5000px solid rgba(0, 0, 0, 0.75);
}
</style>
